import { render } from "./contactUS.vue?vue&type=template&id=2fc459a4"
import script from "./contactUS.vue?vue&type=script&lang=js"
export * from "./contactUS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__